import Exception from './Exception'

function Exception404() {
  return <Exception type="404" />
}

export default Exception404
